import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$8 } from './button.js';
import { d as defineCustomElement$7 } from './dropdown.js';
import { d as defineCustomElement$6 } from './icon.js';
import { d as defineCustomElement$5 } from './icon-button.js';
import { d as defineCustomElement$4 } from './menu.js';
import { d as defineCustomElement$3 } from './spinner.js';
import { d as defineCustomElement$2 } from './text-field.js';

const trayActionCardFieldCss = ".tray-action-card-field{display:flex;flex-direction:row;column-gap:0.5rem;align-items:center}.tray-action-card-field .drag-handle{display:flex;align-items:center;font-size:1.25rem}.tray-action-card-field .field-name{flex-grow:1}.tray-action-card-field .dropdown-trigger::part(base){padding-inline:0.375rem}";

const TrayActionCardField = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.ttChange = createEvent(this, "tt-change", 7);
    this.ttClick = createEvent(this, "tt-delete", 7);
    this.placeholder = 'Field name';
    this.type = 'text-short';
    this.value = undefined;
  }
  connectedCallback() {
    this.onDeleteHandler = this.onDeleteHandler.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
  }
  onDeleteHandler(event) {
    if (event.target === event.currentTarget) {
      this.ttClick.emit();
    }
  }
  handleValueChange(event) {
    this.value = event.detail.value;
    this.ttChange.emit({ type: this.type, value: this.value });
    event.stopPropagation();
  }
  handleTypeChange(event) {
    this.type = event.detail.item.value;
    this.ttChange.emit({ type: this.type, value: this.value });
  }
  render() {
    return (h("div", { class: "tray-action-card-field" }, h("div", { class: "drag-handle" }, h("slot", { name: "prefix" })), h("tt-dropdown", { placement: "bottom-start", hoist: true }, h("tt-button", { class: "dropdown-trigger", slot: "trigger", variant: "light", color: "secondary", size: "small" }, h("tt-icon", { library: "one/webinars", name: this.type })), h("tt-menu", { "onTt-select": this.handleTypeChange }, h("slot", { name: "type-option" }))), h("tt-text-field", { class: "field-name", name: "action-card-field-name", label: "Field name", "hide-label": "true", placeholder: this.placeholder, size: "small", value: this.value, "onTt-change": this.handleValueChange }), h("tt-button", { class: "remove-field", variant: "light", color: "secondary", size: "small", circle: true, onClick: this.onDeleteHandler }, h("tt-icon", { library: "one", name: "close" }))));
  }
  static get style() { return trayActionCardFieldCss; }
}, [1, "tt-tray-action-card-field", {
    "placeholder": [1],
    "type": [1537],
    "value": [1537]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-tray-action-card-field", "tt-button", "tt-dropdown", "tt-icon", "tt-icon-button", "tt-menu", "tt-spinner", "tt-text-field"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-tray-action-card-field":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, TrayActionCardField);
      }
      break;
    case "tt-button":
      if (!customElements.get(tagName)) {
        defineCustomElement$8();
      }
      break;
    case "tt-dropdown":
      if (!customElements.get(tagName)) {
        defineCustomElement$7();
      }
      break;
    case "tt-icon":
      if (!customElements.get(tagName)) {
        defineCustomElement$6();
      }
      break;
    case "tt-icon-button":
      if (!customElements.get(tagName)) {
        defineCustomElement$5();
      }
      break;
    case "tt-menu":
      if (!customElements.get(tagName)) {
        defineCustomElement$4();
      }
      break;
    case "tt-spinner":
      if (!customElements.get(tagName)) {
        defineCustomElement$3();
      }
      break;
    case "tt-text-field":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const TtTrayActionCardField = TrayActionCardField;
const defineCustomElement = defineCustomElement$1;

export { TtTrayActionCardField, defineCustomElement };
